import {
  ChainPublicClientService,
  prodProtocolKeys,
  ProdProtocolKeyService,
  ProtocolKeyService,
  PublicClientService,
} from "@silo/types";
import { Array, Effect, pipe } from "effect";
import { sourceKvMarketMeta } from "./source-kv-market-meta";
import { KvClient } from "../../kv-client";

export type UpdateKvMarketMeta = ReturnType<typeof updateKvMarketMeta>;
export type UpdateKvMarketMetaSuccess =
  Effect.Effect.Success<UpdateKvMarketMeta>;
export type UpdateKvMarketMetaError = Effect.Effect.Error<UpdateKvMarketMeta>;
export type UpdateKvMarketMetaContext =
  Effect.Effect.Context<UpdateKvMarketMeta>;

export function updateKvMarketMeta() {
  return Effect.gen(function* () {
    const { getPublicClient } = yield* PublicClientService;

    const kvMarketMetaArray = yield* pipe(
      Effect.all(
        prodProtocolKeys.map((protocolKey) =>
          pipe(
            sourceKvMarketMeta(),
            Effect.provideService(ProdProtocolKeyService, protocolKey),
            Effect.provideService(ProtocolKeyService, protocolKey),
            Effect.provideService(ChainPublicClientService, {
              publicClient: getPublicClient(protocolKey),
            })
          )
        ),
        { concurrency: "unbounded" }
      ),
      Effect.andThen(Array.flatten)
    );

    yield* KvClient.updateMarketMeta(kvMarketMetaArray);
  });
}
